<template>
  <div class="root">
    <!-- ツールバー -->
    <Toolbar :currentView="currentView" :jsonData="jsonData" :productInfo="productInfo" :isDocomo="isDocomo" :isAu="isAu" @transitionHome="clickToolbarLogo = true" @showLessonScore="showLessonScore = true" @showSetting="showSetting = true" @audioPause="doAudioPause"></Toolbar>

    <!-- currentviewが変更されると、中身が変更する -->
    <component v-bind:is="currentView" :jsonData="jsonData" :productInfo="productInfo" :clickToolbarLogo="clickToolbarLogo" :showLessonScore="showLessonScore" :showSetting="showSetting" :showMicrophoneSelect="showMicrophoneSelect" :isDocomo="isDocomo" :showProgressHandOver="showProgressHandOver" @startLesson="startLesson" @endLesson="endLesson" @showError="showError"　@audioPause="doAudioPause"　@showMicrophoneSelect="goMicrophoneSelect" @showProgressHandOver="goProgressHandOver" @showLessonScore="showLessonScore = true"></component>

    <!-- ロード画面 -->
    <Loading v-if="showLoading" />
    <!-- レッスンスコア画面表示 -->
    <LessonScore v-if="showLessonScore" :productInfo="productInfo" @close="showLessonScore = false" @showError="showError"/>
    <!-- 設定画面 -->
    <Setting v-if="showSetting" :isDocomo="isDocomo" @close="showSetting = false" @showMicrophoneSelect="goMicrophoneSelect" @showMicrophoneSetting="goMicrophoneSetting" @showError="showError" @showFlashHelp="showFlashHelp = true" />
    <!-- マイク選択画面 -->
    <MicrophoneSelect v-if="showMicrophoneSelect" @close="showMicrophoneSelect = false" @showMicrophoneSetting="goMicrophoneSetting" @showMicrophoneHelp="showMicrophoneHelp = true" @showError="showError" :isSettingApply="isSettingApply" />
    <!-- マイク設定画面 -->
    <MicrophoneSetting v-if="showMicrophoneSetting" @close="showMicrophoneSetting = false" @showMicrophoneHelp="showMicrophoneHelp = true" :microphone="microphone" />
    <!-- マイク設定ヘルプ画面 -->
    <MicrophoneHelp v-if="showMicrophoneHelp" @close="showMicrophoneHelp = false" />
    <!-- 進捗引継ぎ確認画面 -->
    <ProgressHandOver v-if="showProgressHandOver" @clickButton="clickProgressHandOver" @close="showProgressHandOver = false"/>

    <!-- エラーダイアログ -->
    <ErrorDialog v-if="showErrDialog" @close="showErrDialog = false" @retry="clickErrRetry" :message="errMessage" :buttonKind="errButtonKind" :isDocomo="isDocomo" :productInfo="productInfo" />
    <!-- Flashヘルプ画面 -->
    <FlashHelp v-if="showFlashHelp" @close="showFlashHelp = false" />
    <!-- アップデート通知 -->
    <Notice v-if="showNotice" @close="closeNotice" />

  </div>
</template>

<script>
import Json from '../../static/data.json'
import Vue from 'vue'
import { mapGetters } from 'vuex'

import * as constants from '@/mixin/constants'
import * as storeConstants from '@/store/constants'
import common from '@/mixin/common'
import http from '@/mixin/http'

import Toolbar from '@/components/Toolbar'
import Home from '@/components/Home'
import Runmode from '@/components/Runmode'
import Loading from '@/components/Loading'
import LessonScore from '@/components/LessonScore'
import ErrorDialog from '@/components/Error'
import Setting from '@/components/Setting'
import MicrophoneSelect from '@/components/MicrophoneSelect'
import MicrophoneSetting from '@/components/MicrophoneSetting'
import MicrophoneHelp from '@/components/MicrophoneSettingHelp'
import ProgressHandOver from '@/components/ProgressHandOver'
import FlashHelp from '@/components/FlashHelp'
import Notice from '@/components/Notice'

var platform = require('platform')

var accessKey = null

export default {
  name: 'root',
  data: function() {
    return {
      currentView: '',
      jsonData: Json.content,
      // runmodeに渡すデータ
      productInfo: Json.productInfo,
      // ロード処理用
      showLoading: false,
      isSreFinished: false,
      isWebApiFinished: false,
      // エラー表示用
      showErrDialog: false,
      errMessage: '',
      errButtonKind: '',
      // ツールバーのロゴ押下
      clickToolbarLogo: false,
      // レッスンスコア画面表示
      showLessonScore: false,
      // 設定画面表示
      showSetting: false,
      // マイク選択画面表示
      showMicrophoneSelect: false,
      isSettingApply: false,
      // マイク設定画面表示
      showMicrophoneSetting: false,
      microphone: null,
      // マイク設定ヘルプ画面表示
      showMicrophoneHelp: false,
      // GETパラメータ：ワンタイムキーの存在確認用
      oneTimeKey: this.$route.query.key,
      // 進捗引継ぎ確認表示用
      showProgressHandOver: false,
      progressHandOverUnitNo: 0,
      progressHandOverLessonIndex: 0,
      progressHandOverPathIndex: 0,
      progressHandOverPathStepIndex: 0,
      progressHandOverLessonJson: null,
      // Flashヘルプ画面表示
      showFlashHelp: false,
       // Docomo版Androidアプリかの判定値 true:Docomo版Androidアプリ false:その他
      isDocomo: false,
      // au版Androidアプリかの判定値
      isAu: false,
      // 学習状態チェック
      studyState: false,
      checkStudyStatus: true,
      // モバイルアプリアップデート通知表示
      showNotice: false
    }
  },
  computed: {
    ...mapGetters([
      'showJapanese',
      'popupDictionaryUse'
    ])
  },
  components: {
    Toolbar,
    Home,
    Runmode,
    Loading,
    LessonScore,
    ErrorDialog,
    Setting,
    MicrophoneSelect,
    MicrophoneSetting,
    MicrophoneHelp,
    ProgressHandOver,
    FlashHelp,
    Notice
  },
  mixins: [
    common,
    http,
  ],
  methods: {
    /**
     * SpeechEngine初期処理
     */
    initEngine: function() {
      var self = this

      // 初期化済みか確認
      if (sonic_wrapper.isSreInitialized()) {
        self.isSreFinished = true
        self.updateLoading()
        return
      }

      // 初期化処理
      var gender = this.$store.getters.gender
      var difficulty = Number(this.$store.getters.difficulty)
      // SREログ出力要否(本番環境ビルドの場合はログ出力無し)
      var needsLog = process.env.DEPLOY_ENV !== 'production'
      // Flash版実行強制フラグ
      var forceFlash = this.isForceFlash()

      // 初期化処理
      this.log("Sonic SRE Load needsLog: " + needsLog + ", forceFlash: " + forceFlash)
      sonic_wrapper.initEngine("en-US", gender, difficulty, needsLog, forceFlash)
        .then(function () {
          self.log("Sonic SRE Initialized.")
          self.outputLogSonicSettings()
        })
        .catch(function (message) {
          self.log(message)
          self.$store.dispatch('setSreUse', "false")
        })
        .then(function () {
          self.isSreFinished = true
          self.updateLoading()
        })
    },
    /**
     * ロード画面更新
     */
    updateLoading: function () {
      this.showLoading = !(this.isSreFinished && this.isWebApiFinished)
      if(!this.showLoading) {
        // 学習状態によって遷移先を変更
        if(this.checkStudyStatus) {
          if(this.studyState) {
            this.startLessonFromContinued()
          } else {
            this.currentView = 'Home'
          }
          this.checkStudyStatus = false;
        } else {
          this.currentView = 'Home'
        }
      }
    },
    /**
     * レッスン開始(Runmode.vueへ切り替える)
     * Home.vueから上がってくるイベント
     */
    startLesson: function() {
      this.log("Root start startLesson")
      this.currentView = 'Runmode'
    },
    /**
     * レッスン終了(Home.vueへ切り替える)
     * Runmode.vueから上がってくるイベント
     */
    endLesson: function() {
      this.log("Root start endLesson")

      this.clickToolbarLogo = false
      this.isWebApiFinished = false

      // state更新
      this.log("set LessonState: " + storeConstants.LESSON_STATE_INIT)
      this.$store.dispatch('setLessonState', storeConstants.LESSON_STATE_INIT)

      // 画面マスク表示
      this.showLoading = true

      // ライセンスチェックAPIを実行
      this.doCheckLicense()
    },
    /**
     * エラーダイアログ表示
     * Runmode.vue/LessonScore.vueから上がってくるイベント
     */
    showError: function(message, buttonKind) {
      this.log("Root start showError message: " + message + ", buttonKind: " + buttonKind)

      if(this.showLessonScore) {
        this.showLessonScore = false
      }

      this.errMessage = message
      this.errButtonKind = buttonKind
      this.showErrDialog = true
    },
    /**
     * エラーダイアログで"再実行"が選択されたときの処理
     */
    clickErrRetry: function() {
      this.log("Root start clickErrRety")
      this.showErrDialog = false
      if (this.errButtonKind === constants.ERROR_BUTTON_KIND_LICENSE) {
        this.doCheckLicense()
        this.errButtonKind = ''
      } else if (this.errButtonKind === constants.ERROR_BUTTON_KIND_ACCESSKEY) {
        this.doGetAccessKey(this.oneTimeKey)
        this.errButtonKind = ''
      }

    },
    /**
     * ライセンスチェック
     */
    doCheckLicense: function() {
      this.log("Root start doCheckLicense")
      var self = this

      if (this.isDocomo || this.isAu) {
        // Docomo/au版の場合は、ライセンスチェック不要
        this.getVaule()
      } else {
        // ライセンスチェックAPIを実行
        this.checkLicense(this.productInfo.code)
        .then(function(response) {
          self.log("Root doCheckLicense resultCode: " + response.result_code)
          switch (response.result_code) {
            case 'OK':
              self.getVaule()
              break
            case 'INFO_INVALID_ACCESSKEY':
              self.errMessage = response.result_code;
              self.errButtonKind = constants.ERROR_BUTTON_KIND_LOGIN
              self.showErrDialog = true
              break
            case 'INFO_INVALID_LICENSE':
              self.errMessage = (self.isEnvironmentPc() ? constants.ERR_LICENSE : constants.ERR_LICENSE_MOBILE).replace(/x/, response.result_code)
              self.errButtonKind = self.isEnvironmentPc() ? constants.ERROR_BUTTON_KIND_SERIAL : constants.ERROR_BUTTON_KIND_LIBRARY
              self.showErrDialog = true
              break
            default:
              self.errMessage = constants.ERR_NETWORK + "(" + response.result_code + ")"
              self.errButtonKind = constants.ERROR_BUTTON_KIND_LICENSE
              self.showErrDialog = true
              break
          }
        })
        .catch(function(err) {
          if(err === '') {
            self.errMessage = constants.ERR_NETWORK
          } else {
            self.errMessage = constants.ERR_NETWORK + "(" + err + ")"
          }
          self.errButtonKind = constants.ERROR_BUTTON_KIND_LICENSE
          self.showErrDialog = true
        })
      }
    },
    /**
     * 設定値を取得する
     */
    getSetting: function() {
      this.log("Root start getSetting")

      var self = this
      return new Promise(function(resolve, reject) {
        // key-value取得APIを実行
        var keyname = constants.DATA_SETTING + '*'
        self.getKeyValue(self.productInfo.code, keyname, accessKey)
        .then(function(response) {
          self.log("Root getSetting resultCode: " + response.result_code)
          switch (response.result_code) {
            case 'OK':
              for(var data of response.data) {
                // storeに保存
                var key = Object.keys(data)
                var json = JSON.parse(JSON.stringify(data))
                if(key[0] === constants.DATA_SETTING_SRE_USE) {
                  self.$store.dispatch('setSreUse', json[key[0]])
                } else if(key[0] === constants.DATA_SETTING_GENDER) {
                  self.$store.dispatch('setGender', json[key[0]])
                } else if(key[0] === constants.DATA_SETTING_DIFFICULTY) {
                  self.$store.dispatch('setDifficulty', json[key[0]])
                } else if(key[0] === constants.DATA_SETTING_AUTO_SCREEN_TRANSITION) {
                  self.$store.dispatch('setAutoScreenTransition', json[key[0]])
                } else if(key[0] === constants.DATA_SETTING_ANSWER_SOUND) {
                  self.$store.dispatch('setAnswerSound', json[key[0]])
                } else if(key[0] === constants.DATA_SETTING_TEXT_SIZE) {
                  self.$store.dispatch('setTextSize', json[key[0]]);
                } else if (key[0] === constants.DATA_SETTING_POPUP_DICTIONARY_USE) {
                  self.$store.dispatch("setPopupDictionaryUse", json[key[0]]);
                }
              }
              resolve()
              break
            case 'INFO_INVALID_ACCESSKEY':
              var message = response.result_code;
              reject(message)
              break
            default:
              reject('')
              break
          }
        })
        .catch(function(err) {
          reject('')
        })
      })
    },
    /**
     * スコア情報を取得する
     */
    getScore: function() {
      this.log("Root start getScore")

      var self = this
      return new Promise(function(resolve, reject) {
        // key-value取得APIを実行
        var keyname = constants.DATA_SCORE + '*'
        self.getKeyValue(self.productInfo.code, keyname, accessKey)
        .then(function(response) {
          self.log("Root getScore resultCode: " + response.result_code)
          switch (response.result_code) {
            case 'OK':
              // storeに保存
              self.$store.dispatch('setScore', response.data)
              self.setStorePathstep(response.data)
              resolve()
              break
            case 'INFO_INVALID_ACCESSKEY':
              var message = response.result_code;
              reject(message)
              break
            default:
              reject('')
              break
          }
        })
        .catch(function(err) {
          reject('')
        })
      })
    },
    /**
     * 進捗情報を取得する
     */
    getProgress: function() {
      this.log("Root start getProgress")

      var self = this
      return new Promise(function(resolve, reject) {
        // key-value取得APIを実行
        var keyname = constants.DATA_PROGRESS + '*'
        self.getKeyValue(self.productInfo.code, keyname, accessKey)
        .then(function(response) {
          self.log("Root getProgress resultCode: " + response.result_code)
          switch (response.result_code) {
            case 'OK':
              // storeに保存
              self.$store.dispatch('setProgress', response.data)
              resolve()
              break
            case 'INFO_INVALID_ACCESSKEY':
              var message = response.result_code;
              reject(message)
              break
            default:
              reject('')
              break
          }
        })
        .catch(function(err) {
          reject('')
        })
      })
    },
    /**
     * マイルストーンの問題データを取得
     */
    getMilestone: function() {
      this.log("Root start getMilestone")

      var self = this
      return new Promise(function(resolve, reject) {
        // key-value取得APIを実行
        var keyname = constants.DATA_MILESTONE + '*'
        self.getKeyValue(self.productInfo.code, keyname, accessKey)
        .then(function(response) {
          self.log("Root getMilestone resultCode: " + response.result_code)
          switch (response.result_code) {
            case 'OK':
              // storeに保存
              self.$store.dispatch('setMilestone', response.data)
              resolve()
              break
            case 'INFO_INVALID_ACCESSKEY':
              var message = response.result_code;
              reject(message)
              break
            default:
              reject('')
              break
          }
        })
        .catch(function(err) {
          reject('')
        })
      })
    },
    /**
     * 学習状態を取得
     */
    getStudyState: function() {
      this.log("Root start getStudyState")

      var self = this
      return new Promise(function(resolve, reject) {
        // key-value取得APIを実行
        var keyname = constants.DATA_STUDY_STATE
        self.getKeyValue(self.productInfo.code, keyname, accessKey)
        .then(function(response) {
          self.log("Root getStudyState resultCode: " + response.result_code)
          switch (response.result_code) {
            case 'OK':
              if (response.data.length == 0) {
                self.studyState = false;
              } else {
                var key = Object.keys(response.data[0])
                var json = JSON.parse(JSON.stringify(response.data[0]))
                if(key[0] === constants.DATA_STUDY_STATE) {
                  if (json[key] === "true") {
                    self.studyState = true
                  } else {
                    self.studyState = false
                  }
                }
              }
              resolve()
              break
            case 'INFO_INVALID_ACCESSKEY':
              var message = response.result_code;
              reject(message)
              break
            default:
              reject('')
              break
          }
        })
        .catch(function(err) {
          reject('')
        })
      })
    },
    /**
     * データを取得
     */
    getVaule: async function() {
      var self = this
      var flag = true

      // アクセスキー取得
      // 非同期処理(WebAPI実行)を並列実行する場合、
      // 事前にアクセスキーを取得する必要があるため、
      // ここで取得
      accessKey = await storage_wrapper.getRsAccessKey()

      Promise.resolve()
      .then(function(){
        return Promise.all([
          // 設定値の取得
          self.getSetting(),
          // スコア情報を取得
          self.getScore(),
          // 進捗を取得
          self.getProgress(),
          // マイルストーン情報を取得
          self.getMilestone(),
          // 学習状態を取得
          self.getStudyState()
        ])
      })
      .catch(function(message) {
        if(message.length != 0) {
          self.errMessage = message
          self.errButtonKind = constants.ERROR_BUTTON_KIND_LOGIN
          self.showErrDialog = true

          flag = false
        }
      })
      .then(function(){
        if(flag) {
          self.isWebApiFinished = true
          self.updateLoading()

          // SRE初期化
          if(!self.isSreFinished) {
            self.initEngine()
          }
        }
      })
    },
    /**
     * storeのレッスンスコアを設定
     */
    setStorePathstep: function(score) {
      for(var item of score) {
        var json = JSON.parse(JSON.stringify(item))
        var key = Object.keys(json)
        var split = this.splitScore(json)

        var setParams = ''
        if(split[5] === 'ok') {
          setParams = {levelNo: split[0], unitNo: split[1], lessonIndex: split[2], pathIndex: split[3], pathstepIndex: split[4], ok: Number(json[key[0]])}
        } else if(split[5] === 'ng') {
          setParams = {levelNo: split[0], unitNo: split[1], lessonIndex: split[2], pathIndex: split[3], pathstepIndex: split[4], ng: Number(json[key[0]])}
        } else {
          setParams = {levelNo: split[0], unitNo: split[1], lessonIndex: split[2], pathIndex: split[3], pathstepIndex: split[4], skip: Number(json[key[0]])}
        }

        // storeへ設定
        this.$store.dispatch('setPathstep', setParams)
      }
    },
    /**
     * マイク選択画面を表示
     */
    goMicrophoneSelect: function(applied) {
      this.showMicrophoneErrorDialog = false
      if (platform.name == "Chrome") {
        this.showMicrophoneSelect = true
        this.isSettingApply = applied
      } else {
        // Chrome以外はマイク設定画面を表示
        this.goMicrophoneSetting(null)
      }
    },
    /**
     * マイク設定画面を表示
     *
     * @param {Object} selectedMicrophone マイクオブジェクト
     */
    goMicrophoneSetting: function(selectedMicrophone) {
      this.microphone = selectedMicrophone
      this.showMicrophoneSetting = true
    },
    /**
     * マイク設定ヘルプ画面を表示
     */
    goMicrophoneHelp: function() {
      this.showMicrophoneHelp = true
    },
    /**
     * 音声停止処理
     * 音声処理がaudio.jsとrunmode.jsのそれぞれにあるので、両方を停止する
     */
    doAudioPause: function() {
      this.log("Root start doAudioPause")

      for(var rootChild of this.$children) {
        if(rootChild.$options.name === 'runmode') {
          // Runmode.vueの子コンポーネントの音声停止
          for(var runmodeChild of rootChild.$children) {
            // audio.js側
            try {
              runmodeChild.audioPause()
            } catch (e) {}
            // runmode.js側
            try {
              runmodeChild.runmodeAudioPause()
            } catch (e) {}

            // さらに子コンポーネントの音声停止
            for(var child of runmodeChild.$children) {
              // audio.js側
              try {
                child.audioPause()
              } catch (e) {}
              // runmode.js側
              try {
                child.runmodeAudioPause()
              } catch (e) {}
            }
          }
          break
        }
      }
    },
    /**
     * アクセスキー取得APIを実行する
     */
    doGetAccessKey: function(oneTimeKey) {
     this.log("Root start doGetAccessKey")
     var self = this

     // アクセスキー取得APIを実行
     this.getAccessKey(oneTimeKey)
     .then( async function(response) {
       self.log("Root doGetAccessKey resultCode: " + response.result_code + " accessKey: " + response.access_key)
         switch (response.result_code) {
           case 'OK':
             // ローカルストレージにアクセスキーを保存
             await storage_wrapper.setRsAccessKey(response.access_key)
             // ライセンスチェックAPIを実行
             self.doCheckLicense()
             break
           case 'INFO_INVALID_ONETIMEKEY':
             self.errMessage = constants.ERR_ONETIMEKEY.replace(/x/, response.result_code)
             self.errButtonKind = constants.ERROR_BUTTON_KIND_LOGIN
             self.showErrDialog = true
             break
           default:
             self.errMessage = constants.ERR_NETWORK + "(" + response.result_code + ")"
             self.errButtonKind = constants.ERROR_BUTTON_KIND_ACCESSKEY
             self.showErrDialog = true
             break
         }
       })
       .catch(function(err) {
         if(err === '') {
           self.errMessage = constants.ERR_NETWORK
         } else {
           self.errMessage = constants.ERR_NETWORK + "(" + err + ")"
         }
         self.errButtonKind = constants.ERROR_BUTTON_KIND_ACCESSKEY
         self.showErrDialog = true
      })
    },
    /**
     * 進捗引き継ぎ確認画面を表示
     */
    goProgressHandOver: function(unitNo, lessonIndex, pathIndex, pathstepIndex, lessonJson) {
      this.log("Root start goProgressHandOver unitNo: " + unitNo + ", lessonIndex: " + lessonIndex + ", pathIndex: " + pathIndex + ", pathstepIndex: " + pathstepIndex)

      this.progressHandOverUnitNo = unitNo
      this.progressHandOverLessonIndex = lessonIndex
      this.progressHandOverPathIndex = pathIndex
      this.progressHandOverPathStepIndex = pathstepIndex
      this.progressHandOverLessonJson = lessonJson

      this.showProgressHandOver = true
    },
    /**
     * 進捗引き継ぎ確認画面でボタンが押下された時の処理
     * ProgressHandOver.vueからあがってくるイベント
     */
    clickProgressHandOver: function(flag) {
      this.log("Root start clickProgressHandOver: " + flag)

      this.showProgressHandOver = false

      if(flag) {
        this.startLessonFromProgressHandOver(this.progressHandOverUnitNo, this.progressHandOverLessonIndex, this.progressHandOverPathIndex, this.progressHandOverPathStepIndex, this.progressHandOverLessonJson)
      } else {
        this.resetData()
      }
    },
    /**
     * 学習状態が学習中の場合に、最後に解答した問題画面に遷移する
     */
    startLessonFromContinued: function() {
      this.log("Root start startLessonFromContinued")

      var progress = this.$store.getters.progress

      if(progress.length != 0) {

        var latestProKey = Object.keys(progress[0])
        var latestProSplit = this.splitProgress(progress[0])
        if(latestProSplit.length != 4) {
          return
        }

        // 表示に必要なデータを設定
        var levelNo = latestProSplit[0]
        var levelJson = this.getLevelJson(this.jsonData, levelNo)
        if(levelJson == null) {
          return
        }

        var unitNo = latestProSplit[1]
        var unitJson = this.getUnitJson(levelJson, unitNo)
        if(unitJson == null) {
         return
        }

        var lesson = latestProSplit[2]
        var path = latestProSplit[3]
        var json = JSON.parse(JSON.stringify(progress[0]))
        var pathstep = Number(json[latestProKey[0]])

        this.$store.dispatch('setLevelNo', levelNo)
        this.$store.dispatch('setUnitNo', unitNo)
        this.$store.dispatch('setLessonIndex', lesson)
        this.$store.dispatch('setPathIndex', path)
        this.$store.dispatch('setPathstepIndex', pathstep)
        this.$store.dispatch('setLessonJson', unitJson.lessons[lesson])

        this.startLesson()
      } else {
        // ホーム画面表示
        this.currentView = 'Home'
      }
    },
    /**
     * リセットしてからレッスン開始
     */
    resetData: function() {
      this.log("Root start resetData")

      var self = this
      var newMilestone = []
      var levelNo = this.$store.getters.levelNo
      var pathstepLength = this.progressHandOverLessonJson.paths[this.progressHandOverPathIndex].pathsteps.length

      // マイルストーンか確認
      if(this.progressHandOverLessonJson.paths[this.progressHandOverPathIndex].title === constants.MILESTONE_TITLE) {
        // 問題再抽出
        var levelJson = this.getLevelJson(this.jsonData, levelNo)
        var unitJson = this.getUnitJson(levelJson, this.progressHandOverUnitNo)
        newMilestone = this.createMilestone(unitJson, levelNo, this.progressHandOverUnitNo)

        // storeのマイルストーンを更新
        var params = {levelNo: levelNo, unitNo: this.progressHandOverUnitNo, question: []}
        for(var item of newMilestone) {
          var val = {data: item}
          params.question.push(val)
        }
        this.$store.dispatch('updateMilestone', params)

        pathstepLength = constants.MILESTONE_QUESTION_COUNT
      }

      // レッスン情報を保存
      this.log("setLessonData levelNo: " + levelNo + ", unitNo: " + this.progressHandOverUnitNo + ", lessonIndex: " + this.progressHandOverLessonIndex + ", pathIndex: " + this.progressHandOverPathIndex + ", pathstepIndex: 0")
      this.$store.dispatch('setLevelNo', levelNo)
      this.$store.dispatch('setUnitNo', this.progressHandOverUnitNo)
      this.$store.dispatch('setLessonIndex', this.progressHandOverLessonIndex)
      this.$store.dispatch('setPathIndex', this.progressHandOverPathIndex)
      this.$store.dispatch('setPathstepIndex', 0)
      this.$store.dispatch('setLessonJson', this.progressHandOverLessonJson)

      // storeのスコアをリセット
      this.$store.dispatch('setPathAllReset')

      // storeの進捗をリセット
      var params = {levelNo: levelNo, unitNo: this.progressHandOverUnitNo, lessonIndex: this.progressHandOverLessonIndex, pathIndex: this.progressHandOverPathIndex, pathstepIndex: 0}
      this.$store.dispatch('updateProgress', params)

      // json作成
      var apiData = ''
      var score = this.createResetScoreDataForApi(levelNo, this.progressHandOverUnitNo, this.progressHandOverLessonIndex, this.progressHandOverPathIndex, pathstepLength)
      var progress = this.createProgressDataForApi(levelNo, this.progressHandOverUnitNo, this.progressHandOverLessonIndex, this.progressHandOverPathIndex, 0)
      if(newMilestone.length != 0) {
        var question = this.createMilestoneDataForApi(levelNo, this.progressHandOverUnitNo, newMilestone)
        apiData = '{"data":[' + score + ',' + progress + ',' + question + ']}'
      } else {
        apiData = '{"data":[' + score + ',' + progress + ']}'
      }

      this.doSetKeyValue(apiData)
      .then(function(){
        self.startLessonFromProgressHandOver(self.progressHandOverUnitNo, self.progressHandOverLessonIndex, self.progressHandOverPathIndex, 0, self.progressHandOverLessonJson)
      })
      .catch(function(message) {
        if(message.length != 0) {
          self.showError(message, constants.ERROR_BUTTON_KIND_LOGIN)
        } else {
          self.startLessonFromProgressHandOver(self.progressHandOverUnitNo, self.progressHandOverLessonIndex, self.progressHandOverPathIndex, 0, self.progressHandOverLessonJson)
        }
      })
    },
    /**
     * 進捗引き継ぎ確認画面からのレッスン開始処理
     */
    startLessonFromProgressHandOver: function(unitNo, lessonIndex, pathIndex, pathstepIndex, lessonJson) {
      this.log("Root start startLessonFromProgressHandOver unitNo: "  + unitNo + ", lessonIndex: " + lessonIndex + ", pathIndex: " + pathIndex + ", pathstepIndex: " + pathstepIndex)

      // 表示中のviewを確認
      if(this.currentView === 'Home') {
        this.startLesson()
      } else {
        for(var child of this.$children) {
          if(child.$options.name === 'runmode') {
            child.startLesson(unitNo, lessonIndex, pathIndex, pathstepIndex, lessonJson)
            break
          }
        }
      }
    },
    /**
     * key-value設定APIを実行
     */
    doSetKeyValue: function(datajson) {
      this.log("Root start doSetKeyValue")
      var self = this

      return new Promise(function(resolve, reject) {
        // key-value設定API
        self.setKeyValue(self.productInfo.code, datajson)
        .then(function(response) {
          self.log("Root doSetKeyValue resultCode: " + response.result_code)
          switch (response.result_code) {
            case 'OK':
              resolve()
              break
            case 'INFO_INVALID_ACCESSKEY':
              var message = response.result_code;
              reject(message)
              break
            default:
              reject('')
              break
          }
        })
        .catch(function(err) {
          reject('')
        })
      })
    },
    /**
     * 端末情報を確認し、端末毎の処理を実行する
     */
    doCheckMachineInfo: function() {

      // 実行環境の確認
      if(!this.isEnvironmentPc()) {
        // モバイルアプリの場合はプラットフォーム名を確認
        if(window.Phone.GetPlatformName() == constants.PLATFORM_ANDROID) {
          // androidの場合はパッケージ名を確認
          if(window.Phone.GetPackageName().startsWith(constants.PACKAGE_DOCOMO_ANDROID)) {
            // Docomo版の場合、アプリバージョンを確認
            try {
              var version = window.Phone.GetVersionCode();
              if(Number(version) < constants.VERSION_DOCOMO_ANDROID) {
                // アップデート通知
                this.showLoading = false;
                this.showNotice = true;
              }
            } catch(e) {
              this.log("GetVersionCode exception: " + e.message);
              // アップデート通知
              this.showLoading = false;
              this.showNotice = true;
            }

            // アクセスキーを取得し、ローカルストレージに保存する
            storage_wrapper.setRsAccessKey(window.Phone.GetAccessKey());
            this.isDocomo = true;

          } else if(window.Phone.GetPackageName().startsWith(constants.PACKAGE_AU_ANDROID)) {
            this.isAu = true;
          }
        }
      }
    },
    /**
     * モバイルアプリアップデート通知を閉じる
     */
    closeNotice: async function() {
      this.showNotice = false;

      // ワンタイムキーがGETパラメータに付与されているか確認
      this.log("oneTimeKeyCheck:" + this.oneTimeKey)
      if(this.oneTimeKey != null){
        await this.doGetAccessKey(this.oneTimeKey)
      } else {
        // ライセンスチェックAPIを実行
        this.doCheckLicense()
      }
    },
    /**
     * JSONデータのBasicテキストを変換する
     * Tile／STile以外で[]付き文字列が設定されている場合は[]を削除し、正解テキストを設定する
     */
    convertBasicText: function() {
      this.log("Root start convertBasicText");

      for (var levelJson of this.jsonData.levels) {
        for (var unitJson of levelJson.units) {
          var lessonIndex = 0;
          for (var lessonJson of unitJson.lessons) {
            lessonIndex++;
            for (var pathJson of lessonJson.paths) {
              var pathstepIndex = 0;
              for (var pathstepJson of pathJson.pathsteps) {
                pathstepIndex++;
                var actIndex = 0;
                // RunmodeがTile／STile以外の場合は[]付きのBasicテキストを正解テキストに変換する
                if (pathstepJson.mode != constants.RUNMODE_TILE && pathstepJson.mode != constants.RUNMODE_STILE) {
                  for (var actJson of pathstepJson.acts) {
                    actIndex++;
                    var basicText = actJson.basicText;
                    // []付きか判定
                    if(basicText.indexOf("[") != -1 && basicText.indexOf("]") != -1) {
                      this.log("Root convertBasicText Level" + levelJson.levelNo + "-Unit" + unitJson.unitNo + "-Lesson" + lessonIndex + "-" + pathJson.title + pathstepIndex + " Act" + actIndex);
                      var textList = basicText.replace(/\[/g, "####[").replace(/\]/g, "]####").split("####");
                      var answerText = "";
                      for (var text of textList) {
                        if (text.match(/\[([^\]]*)\]/g)) {
                          // []付きの箇所は正解テキスト（リストの最初）に変換
                          answerText += text.replace(/\[|\]/g, "").split("/")[0];
                        } else {
                          answerText += text;
                        }
                      }
                      this.log("Root convertBasicText convert 「" + actJson.basicText + "」 to 「" + answerText + "」");
                      actJson.basicText = answerText;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  },
  created: function() {
    this.log("Root start created")
    this.convertBasicText();

    // state更新
    this.log("set LessonState: " + storeConstants.LESSON_STATE_INIT)
    this.$store.dispatch('setLessonState', storeConstants.LESSON_STATE_INIT)

    // 画面マスク表示
    this.showLoading = true

    // storeのレッスンスコアを初期化
    this.$store.dispatch('initLessonScore', this.jsonData.levels)
  },
  mounted: async function() {
    this.log("Root start mounted")
    const self = this;
    // ローカルストレージ操作初期化処理
    await storage_wrapper.initialize(this.$parent.iframeId, process.env.WEB_API_ORIGIN)
    // ポップアップ辞書初期設定(PCの場合のみ)
    if(this.isEnvironmentPc()) {
      popupDictionary.initialize(
        constants.POPUP_DICTIONARY_SETTINGS.isProdution,
        constants.POPUP_DICTIONARY_SETTINGS.popupOption,
        constants.POPUP_DICTIONARY_SETTINGS.popupSpeed,
        constants.POPUP_DICTIONARY_SETTINGS.language,
        constants.POPUP_DICTIONARY_SETTINGS.showSetting
      );
      // ポップアップ辞書でアクセスキー無効になった際の処理
      document.body.addEventListener(DIC_EVENT_NAME_INVALID_ACCESSKEY, function() {
        self.doAudioPause();
        self.errMessage = "INFO_INVALID_ACCESSKEY";
        self.errButtonKind = constants.ERROR_BUTTON_KIND_LOGIN
        self.showErrDialog = true
      });
      // ポップアップ辞書の設定画面表示ボタン押下時の処理
      document.body.addEventListener(DIC_EVENT_NAME_OPEN_SETTING, function() {
        self.doAudioPause();
        self.showSetting = true;
      })
      // ポップアップ辞書表示時の処理
      document.body.addEventListener(DIC_EVENT_NAME_DISP_POPUP, function() {
        // GoogleAnalyticsページビューヒット送信
        rosettaGA.sendPageView(constants.GA_PAGEVIEW_TITLE, constants.GA_PAGEVIEW_PAGE, [self.productInfo.code]);
      })
    }

    // 端末毎の処理を実行
    this.doCheckMachineInfo()
    if(this.showNotice) {
      return;
    }

    // ワンタイムキーがGETパラメータに付与されているか確認
    this.log("oneTimeKeyCheck:" + this.oneTimeKey)
    if(this.oneTimeKey != null){
      await this.doGetAccessKey(this.oneTimeKey)
    } else {
      // ライセンスチェックAPIを実行
      this.doCheckLicense()
    }

  },
  watch: {
    showJapanese: function(newStatus) {
      if(!this.isEnvironmentPc()) {
        // モバイルアプリの場合、何もしない
        return;
      }

      if (newStatus) {
        popupDictionary.changeSettings(DIC_OPTIONS_DISABLED, null, null);
      } else {
        popupDictionary.changeSettings(constants.POPUP_DICTIONARY_SETTINGS.popupOption, null, null);
      }
    },

    /**
     * ポップアップ辞書表示設定変更監視
     * @param {type} newStatus 変更後の値
     */
    popupDictionaryUse: function(newStatus) {
      if(newStatus === "true") {
        popupDictionary.changeSettings(constants.POPUP_DICTIONARY_SETTINGS.popupOption, null, null);
      } else {
        popupDictionary.changeSettings(DIC_OPTIONS_DISABLED, null, null);
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Root.vue?36ef70b1